import { render, staticRenderFns } from "./ListagemLoteLivros.vue?vue&type=template&id=4751f4ee&"
import script from "./ListagemLoteLivros.vue?vue&type=script&lang=js&"
export * from "./ListagemLoteLivros.vue?vue&type=script&lang=js&"
import style0 from "./ListagemLoteLivros.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports